import React, { useState } from "react";
// import { SingleValue } from "react-select";

import CreatableSelect from "react-select/creatable";

const createOption = (label) => ({
  label: label,
  value: label,
});

const CreateableMenu = (props) => {
  const [isLoading, setIsLoading] = useState(props.readonly);
  // const [options, setOptions] = useState(props.options);
  // const [value, setValue] = useState(props.defaultValue);

  // setOptions(props.options);
  const handleCreate = (inputValue) => {
    setIsLoading(true);
    setTimeout(() => {
      const newOption = createOption(inputValue);
      setIsLoading(false);
      // setOptions((prev) => [...prev, newOption]);
      // setValue(newOption);
      handleChange(newOption);
      props.creatableCallback(newOption);
    }, 500);
  };

  const handleChange = (value) => {
    if (value) props.onChange(value);
    // setValue(value);
  };

  return (
    <CreatableSelect
      classNamePrefix="rs"
      isClearable={false}
      isDisabled={isLoading}
      isLoading={isLoading}
      onChange={handleChange}
      onCreateOption={handleCreate}
      options={props.options}
      value={props.defaultValue}
      isMulti={props.isMultiple}
    />
  );
};

export default CreateableMenu;
